/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { Interpreter, InterpreterInterface } from "../Interpreter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "pearlToken_",
        type: "address",
      },
      {
        internalType: "address",
        name: "goldOreToken_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "onlyBadEvent",
        type: "bool",
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bytes32[]",
            name: "rewardTokens",
            type: "bytes32[]",
          },
          {
            internalType: "bytes32[]",
            name: "locationEventTypeConfig",
            type: "bytes32[]",
          },
          {
            internalType: "uint32[]",
            name: "locationExtraConfig",
            type: "uint32[]",
          },
          {
            internalType: "bytes32",
            name: "locationEventTypeDistribution",
            type: "bytes32",
          },
        ],
        internalType: "struct IExpedition.InterpreterParams",
        name: "interpreterParams",
        type: "tuple",
      },
      {
        internalType: "bytes32[]",
        name: "characters",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "inventory",
        type: "bytes32[]",
      },
    ],
    name: "calculateEvent",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "aliveCharacters",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "deadCharacters",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32[]",
        name: "updatedInventory",
        type: "bytes32[]",
      },
      {
        internalType: "bytes32",
        name: "eventVariation",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "characters",
        type: "bytes32[]",
      },
    ],
    name: "getCharacterPrices",
    outputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "prices",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    name: "getCharacters",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "characters",
        type: "bytes32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "characters",
        type: "bytes32[]",
      },
    ],
    name: "getNumberOfItems",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "characters",
        type: "bytes32[]",
      },
    ],
    name: "parseCharacters",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "characterIndex",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "characterType",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "health",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "attack",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "defense",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "pearlPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "goldOrePrice",
            type: "uint256",
          },
        ],
        internalType: "struct IInterpreter.Character[]",
        name: "parsedCharacters",
        type: "tuple[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class Interpreter__factory {
  static readonly abi = _abi;
  static createInterface(): InterpreterInterface {
    return new Interface(_abi) as InterpreterInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Interpreter {
    return new Contract(address, _abi, runner) as unknown as Interpreter;
  }
}
